import { render, staticRenderFns } from "./ScheduleFrequencyWeek.vue?vue&type=template&id=4eb285a4&scoped=true"
import script from "./ScheduleFrequencyWeek.vue?vue&type=script&lang=js"
export * from "./ScheduleFrequencyWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb285a4",
  null
  
)

export default component.exports